/**
 * File navigation.js.
 */

const initFitNav = (nav) => {
    const menu = nav.querySelector(':scope > .menu, :scope > ul');
    if (!menu) {
        return;
    }

    let more = menu.querySelector(':scope > .menu-item-more');
    if (!more) {
        more = document.createElement('li');
        more.className = 'menu-item menu-item-has-children menu-item-more';
        more.innerHTML = '<div class="menu-item">More<span class="menu-item-expand"></span></div><ul class="sub-menu"></ul>';
        more.hidden = true;
        menu.appendChild(more);
    }

    const moreList = more.querySelector(':scope > .sub-menu');
    let frame = 0;

    const getItems = () => [...menu.children].filter((el) => el.matches('li') && !el.classList.contains('menu-item-more'));

    // Sum real item widths — do not rely on scrollWidth (unreliable with flex + nowrap).
    const contentWidth = () => {
        let width = 0;
        getItems().forEach((item) => {
            width += item.getBoundingClientRect().width;
        });
        if (!more.hidden) {
            width += more.getBoundingClientRect().width;
        }
        return width;
    };

    const overflows = () => contentWidth() - nav.clientWidth > 1;

    const restoreItems = () => {
        [...moreList.children].forEach((item) => {
            menu.insertBefore(item, more);
        });
        more.hidden = true;
    };

    const fit = () => {
        restoreItems();

        if (nav.clientWidth < 2 || getComputedStyle(menu).display === 'none') {
            return;
        }

        if (!overflows()) {
            return;
        }

        more.hidden = false;
        void more.offsetWidth;

        const items = getItems();

        // Collapse from the end; keep at least the first item visible.
        for (let i = items.length - 1; i >= 1; i--) {
            if (!overflows()) {
                break;
            }
            moreList.insertBefore(items[i], moreList.firstChild);
        }

        if (!moreList.children.length) {
            more.hidden = true;
        }
    };

    const scheduleFit = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(fit);
    };

    if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(scheduleFit).observe(nav);
    } else {
        window.addEventListener('resize', scheduleFit);
    }

    if (document.fonts?.ready) {
        document.fonts.ready.then(scheduleFit);
    }

    window.addEventListener('load', scheduleFit);
    scheduleFit();
};

document.querySelectorAll('[data-fit-nav]').forEach(initFitNav);

window.addEventListener('scroll', () => {
    if (window.scrollY > 200) {
        document.body.classList.add('has-sticky-header');
        document.body.classList.remove('has-sticky-header-animate-out');
        document.body.classList.add('has-sticky-header-animate-in');
    } else {
        document.body.classList.remove('has-sticky-header-animate-in');
        document.body.classList.add('has-sticky-header-animate-out');
        document.body.classList.remove('has-sticky-header');
    }
});

document.querySelectorAll('.menu-btn').forEach((menu) => {
    menu.addEventListener('click', () => {
        document.body.classList.toggle('mobile-menu-open');
        if (document.body.classList.contains('mobile-menu-open')) {
            document.body.classList.add('mobile-menu-open--animate-open');
            setTimeout(() => {
                document.body.classList.remove('mobile-menu-open--animate-open');
            }, 1000);
        } else {
            document.body.classList.add('mobile-menu-open--animate-close');
            setTimeout(() => {
                document.body.classList.remove('mobile-menu-open--animate-close');
            }, 1000);
        }
    });
});

document.querySelectorAll('.menu-item-has-children:has(.menu-item-expand) a').forEach((item) => {
    item.addEventListener('click', (e) => {
        if (e.target.classList.contains('menu-item-expand')) {
            e.preventDefault();

            const hasExpanded = item.parentElement.classList.contains('menu-expanded');

            item.parentElement.parentElement.querySelectorAll('.menu-item-has-children:has(.menu-item-expand) a').forEach((item) => {
                item.parentElement.classList.remove('menu-expanded');
            });

            if (hasExpanded) {
                item.parentElement.classList.remove('menu-expanded');
            } else {
                item.parentElement.classList.add('menu-expanded');
            }
        }
    });
});

document.querySelectorAll('footer .col-item-mobile-expand').forEach((item) => {
    item.addEventListener('click', (e) => {
        if (e.target.classList.contains('text27')) {
            e.preventDefault();
            const hasExpanded = item.classList.contains('menu-expanded');
            if (hasExpanded) {
                item.classList.remove('menu-expanded');
            } else {
                item.classList.add('menu-expanded');
            }
        }
    });
});

document.querySelectorAll('.menu-item .icon-cart').forEach((item) => {
    item.addEventListener('click', () => {
        document.querySelectorAll('.header-mini-cart').forEach((cart) => {
            cart.classList.toggle('cart-open');
        });
    });
});

document.body.addEventListener('click', function (e) {
    if (!e.target.matches('.nav-mobile-container, .nav-mobile-container *, .main-navigation .menu-btn, .main-navigation .menu-btn *, .header-mini-cart *')) {
        document.body.classList.remove('mobile-menu-open');
        document.body.classList.add('mobile-menu-open--animate-close');
        setTimeout(() => {
            document.body.classList.remove('mobile-menu-open--animate-close');
        }, 1000);
    }

    if (!e.target.matches('.menu-item:has(.icon-cart), .menu-item:has(.icon-cart) *, .header-mini-cart, .header-mini-cart *')) {
        document.querySelectorAll('.header-mini-cart').forEach((cart) => {
            cart.classList.remove('cart-open');
        });
    }
});
